import {styled, Theme} from "@mui/material/styles";
import Container from "@mui/material/Container";

export const AppContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '100vh',
    overflow: 'hidden',
});

export const BodyContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
}));

export const ContentContainer = styled(Container)(({ theme }) => ({
    flex: '1 1 auto',
    background: theme.palette.background.paper,
    minHeight: 0,
    overflowY: 'auto',
    paddingBottom: theme.spacing(10), // Increased to ensure content is not hidden behind fixed footer
}));
